// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"9":"f489189b","23":"fc85de2e","54":"0e9a6bfc","182":"07ece654","496":"c53690f0","644":"4c2ffa8c"}[chunkId] + ".js";
};